<template>
<div :class="{'dfm-content': isInDFM}">
	<dfm-nav></dfm-nav>
	<quote-box style="position:relative;">
		<div class="quote-smttab" :class="{'quote-tab-fixed':isFixed && !isMinWidth}" :data-quoteon="getSmtquoteOn">
			<a class="quote-smttab_step vlm guide-step1" :class="{on:on === 0}" @click="changepage(0)">
				<i class="icon vlm">1</i>  
				<em class="vlm">PCB</em>
			</a>  
			<i class="icon vlm quote-smttab_space fc-dis fs-sm">
				&#xe601;
			</i> 
			<a class="quote-smttab_step vlm" :class="{on:on === 1}" @click="changepage(1)">
				<i class="icon vlm">2</i> 
				<em class="vlm">PCB Assembly</em>
			</a> 
		</div>
		<quote-pcb v-show="on === 0"></quote-pcb>
		<quote-smt v-show="on === 1"></quote-smt>
		<!-- pcb -->

		<!-- pcba quote 新手引导 20240104下架新手引导 -->
		<PCBAGuide v-if="0" @handleChangeTab="handleChangeTab" @handleFinishGuide="handleCloseGuide"></PCBAGuide>
	</quote-box>
</div>
</template>

<script>
import quoteBox from '@/views/quote/quote_box.vue'
import quoteSmt from '@/components/quote/smt.vue'
import quotePcb from '@/components/quote/pcb.vue'
import PCBAGuide from '@/components/guide/pcba-guide.vue'
import DfmNav from '@/components/dfmNav.vue'
export default {
	components: {
		'quote-box': quoteBox,
		'quote-smt':quoteSmt,
		'quote-pcb':quotePcb,
		PCBAGuide,
		DfmNav
	},
	computed:{
		getSmtquoteOn(){
			//quote-smttab setsmtQuoteOn
			return this.$store.getters.getSmtquoteOn;
		},
		isLogin(){
			return this.$store.getters.isLogin;
		},
		loginInfo(){
			return this.$store.getters.getLoginInfo;
		},
		isInDFM(){
			if(window.isInDFM){
				return JSON.parse(window.isInDFM)
			}
			else{
				return false
			}
		},
		isFixed(){
			return this.$store.state.isFixed
		},
		isMinWidth(){
			return this.$store.state.isMinWidth
		},
	},
	data(){
		return {
			on:0,
			showGuide: false //是否打开新手引导
		}
	},
	mounted(){
		this.handleOpenGuide()
	},
	methods:{
		changepage(type){
			this.on = type;
			window.scroll({top:0, left:0 , behavior: 'smooth'})
			this.$store.commit("setsmtQuoteOn",type);
		},
		// 打开引导
		handleOpenGuide(){
			const hasGuide=window.localStorage.getItem('showGuide')
			if(this.isLogin){
				if(!this.loginInfo.recordOperatingInstruction && !hasGuide){
					this.showGuide=true
				}
			}
			else {
				if(!hasGuide){
					this.showGuide=true
				}
			}
		},
		// 关闭引导
		handleCloseGuide(){
			this.showGuide=false
			if(this.on !==0){
				this.changepage(0)
			}
		
			if(this.isLogin){
				// 调用接口保存
				try {
					this.$http.post(this.$api.saveGuide, { memberId:this.loginInfo.userId }).then((res)=>{})
				} catch (error) {
					console.error(error)
				}
				
			}
			else{
				window.localStorage.setItem('showGuide','1')
			}
		},
		// 引导页面切换tab
		handleChangeTab(){
			const tab= this.on === 0 ? 1 :0 
			this.changepage(tab)
		}
		
	},
	watch:{
		getSmtquoteOn:{
			handler(v){
				this.on = v
			},
			immediate:true
		}
	}
}
</script>
<style lang="scss">
$tabHeight:40px;
.quote-smttab {	
	position: relative;
	background-color: #fff;
	border-radius: 2px;
	border-bottom: 2px solid #e6e6e6;	
	box-sizing: border-box;	
	margin-bottom: 12px;
	&_step {
		height: $tabHeight;
		line-height: $tabHeight;	
		width: 200px;		
		text-align: center;
		cursor: pointer;
		position: relative;
		em {
			font-weight: bold;
			font-size: 16px;
		}
		.icon {
			width: 16px;
			height: 16px;
			background: #c00;
			border: 2px solid #c00;
			border-radius: 50%;
			display: inline-block;
			vertical-align: middle;
			line-height: 16px;
			font-size: 12px;
			font-weight: bold;
			margin-right: 8px;
			color: #FFF;
		}
		&.on{
			color: #cc0000;
			&::after {
				content: "";
				position: absolute;
				z-index: 5;
				left: 0;
				right: 0;
				bottom: -2px;
				height: 2px;
				background-color: #cc0000;
			}
			.icon {
				border-color: #cc0000;
			}
		}
	}
	&_space {
		position: absolute;
		height: $tabHeight;
		width: $tabHeight;
		line-height: $tabHeight;
		text-align: right;
		top: 0;
		left: calc(200px - $tabHeight);
	}
}

.quote-tab-fixed{
	width: calc(1200px * 0.683333 );
	position: fixed;
	left: 50%;
	top: calc(48px + 60px);
	transform: translateX(-50%);
	margin-left: -190px;
	z-index: 100;
}
</style>
